import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import AppContext from '../../../../../Context/AppContext';
import ELearningCard from '../ELearningCard';

const MyBreakthrough = ({
    loaded,
    completeLength,
    uncompleteLength,
    unlockedLength,
    height,
    modules,
    typeModules,
    configData,
    isCoachFromSteps,
}) => {
    const { checkUserSession } = useContext(AppContext);
    const userInfo = checkUserSession();
    
    // Obtener el userStepId de la sesión (cookie) o localStorage como fallback
    const userStepId = parseInt(
        userInfo?.userStepId || localStorage.getItem('userStepId') || 0, 
        10
    );
    const isActiveCoach = localStorage.getItem('isActiveCoach') === 'true';
    const userTypeId = userInfo?.userTypeId;
    
    // DEBUG: Log para investigar el problema
    console.log('=== MyBreakthrough DEBUG ===');
    console.log('userInfo:', userInfo);
    console.log('userStepId:', userStepId, 'type:', typeof userStepId);
    console.log('userTypeId:', userTypeId);
    console.log('isActiveCoach:', isActiveCoach);
    console.log('loaded:', loaded);
    console.log('unlockedLength:', unlockedLength);
    console.log('modules.myBreakthroughExperience:', modules.myBreakthroughExperience);
    console.log('shouldShowStepsMessage:', isActiveCoach && userStepId < 4);
    console.log('hasAccess:', (userStepId >= 4 || isActiveCoach) && userTypeId !== 4);
    console.log('shouldShowCreateButton:', loaded === true && unlockedLength === 0);
    console.log('===========================');
    
    // Validar si el usuario tiene acceso a My Breakthrough Experience
    // Debe tener userStepId >= 4 (completó los steps) O ser un coach activo
    // Y NO debe ser userTypeId === 4 (non-subscriber)
    const hasAccess = (userStepId >= 4 || isActiveCoach) && userTypeId !== 4;
    
    // Determinar si debe mostrar el mensaje para completar Design My Life Blueprint
    // Se muestra si el usuario no ha completado los steps (userStepId < 4) y no es non-subscriber
    const shouldShowStepsMessage = userStepId < 4 && userTypeId !== 4;
    const history = useHistory();
    
    const MyBreakthroughR =
        shouldShowStepsMessage ? (
            <section className="paragraph-3 ModuleDescription">
                <p>
                    <span>
                        Complete all the "Design My Life Blue Print" Experience before you start "My Breakthrough".
                    </span>
                </p>
                <span>PHASE 2:</span> A new module unlocks every 7 days for 12-weeks.
                <br />
                <br />
                <button
                    className="eLearningBoard__createYourCourse"
                    onClick={() => history.push('/steps')}
                    type="button"
                    style={{ 
                        backgroundColor: '#d86b59', 
                        color: 'white', 
                        border: 'none', 
                        padding: '10px 20px', 
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '2.5rem'
                    }}
                >
                    Go to Design My Life Blueprint
                </button>
            </section>
        ) : hasAccess && loaded === true && unlockedLength === 0 ? (
            <article className="eLearningBoardCreate">
                <h5 className="heading-5">My Breakthrough Experience</h5>
                <button
                    className="eLearningBoard__createYourCourse"
                    onClick={() => history.push('/assessment?AssessmentType=1')}
                    type="button"
                >
                    CREATE YOUR
                    <br /> CUSTOM PROGRAM HERE!
                    <svg>
                        <g transform="translate(40 40)">
                            <g
                                className="pulseAnimation"
                                style={{ opacity: '0.5' }}
                            >
                                <circle r="30" fill="white" />
                                <circle r="28" fill="#d86b59" />
                                <circle r="22" fill="white" />
                            </g>
                        </g>
                    </svg>
                </button>
            </article>
        ) : (
            <div className='MyBreakThroughModules__container'>
                <section className="paragraph-3 ModuleDescription">
                    <p className="TitleContentElearning">
                        My Breakthrough Experience: {completeLength}/
                        {modules.myBreakthroughExperience.length}
                    </p>
                    <span>PHASE 2:</span> A new module unlocks every 7 days for
                    12-weeks
                </section>

                <div className="eLearningBoard__modules Oolascroll">
                    {modules.myBreakthroughExperience.map((item, i) => (
                        <ELearningCard
                            index={i}
                            height={height}
                            item={item}
                            configData={configData}
                            showLeftBorder={i % 2}
                            key={item.id}
                        />
                    ))}
                </div>
            </div>
        );

    return MyBreakthroughR;
};

export default MyBreakthrough;
